export const sets: TableModule = {
    name: "sets",
    route: "spa.questions.sets",
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "description",
        },
        {
            name: "created_at",
            sortable: true,
            mobile: true,
            width: "w-[150px]"
        }
    ],
    filters: [
        {
            name: "id",
            column: "sets.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "sets.name",
            type: "string",
            reduced: true
        },
        {
            name: "description",
            column: "sets.description",
            type: "string",
            reduced: true
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "sets"]
        },
        {
            name: 'sets.delete',
            ability: ["delete", "sets"]
        }
    ]
}